/** @flow */
import * as React from 'react';
import { translate } from 'react-i18next';
import StreamLiveMetrics from '../domain/StreamLiveMetrics';

export const LIVE_METRICS_NUMBER_ID = 'live-metrics-number';

type Props = {
  liveMetrics: StreamLiveMetrics;
  t: any;
};

export function StreamingLiveMetricsHeader(props: Props) {
  return (
    <div className="col-md-6">
      <h4>{props.t('streamStatus')}</h4><p>{props.liveMetrics.streamStatus}</p>
      { !props.liveMetrics.error &&
        <div id={LIVE_METRICS_NUMBER_ID}>
          <h4>{props.t('nbOfConnections')}</h4><p>{props.liveMetrics.nbOfConnections}</p>
          <h4>{props.t('bitrate')}</h4><p>{props.t('bitrateUnits', { value: props.liveMetrics.bitrate })}</p>
        </div>
      }
      { props.liveMetrics.error &&
        <p>{props.t('errorWhileFetchingLiveMetricsMessage')}</p>
      }
    </div>

  );
}

export default translate('streaming')(StreamingLiveMetricsHeader);



// WEBPACK FOOTER //
// ./src/statsradio/modules/streaming/component/StreamingLiveMetricsHeader.js